import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import HomeLogged from '../../../components/auth/home'

function HomeLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Transparência - Administrador" />
                <HeaderLogged />
                <Container>
                   <HomeLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default HomeLoggedScreen;